module.exports = __webpack_public_path__ + "img/c16e16a.jpg";